import { useCallback, useState } from 'react';
import { HeaderMenuLeft } from './HeaderMenuLeft';
import { HeaderMenuRight } from './HeaderMenuRight';
import type { WorkspaceEntity } from '@workspace/domain/workspace';
import type { ViewModelEntity } from '@view-model/domain/view-model';
import type { Rect } from '@view-model/models/common/basic/Rect';
import type { CurrentMenu } from './HeaderMenuRight/HeaderMenuRight';
import type { ViewModelPermissions } from '@view-model/application/context';

type Props = {
  currentMenu: CurrentMenu;
  setCurrentMenu: (menu: CurrentMenu) => void;
  workspace: WorkspaceEntity;
  viewModel: ViewModelEntity;
  viewModelPermissions: ViewModelPermissions;
  setClientViewBox: (viewBox: Rect) => void;
  onGenerateLink(): void;
  onExportViewModelAsImage(isWhole: boolean): void;
};

export const HeaderMenuFirst: React.FC<Props> = ({
  currentMenu,
  setCurrentMenu,
  workspace,
  viewModel,
  viewModelPermissions,
  setClientViewBox,
  onGenerateLink,
  onExportViewModelAsImage,
}: Props) => {
  const [showTimer, setShowTimer] = useState(false);

  const handleOpenTimer = useCallback(() => {
    setShowTimer(true);
  }, []);

  const handleCloseTimer = useCallback(() => {
    setShowTimer(false);
  }, []);

  return (
    <>
      <HeaderMenuLeft
        viewModel={viewModel}
        workspace={workspace}
        viewModelPermissions={viewModelPermissions}
        onGenerateLink={onGenerateLink}
        onOpenTimer={handleOpenTimer}
        onExportViewModelAsImage={onExportViewModelAsImage}
      />

      <HeaderMenuRight
        setClientViewBox={setClientViewBox}
        currentMenu={currentMenu}
        setCurrentMenu={setCurrentMenu}
        showTimer={showTimer}
        onOpenTimer={handleOpenTimer}
        onCloseTimer={handleCloseTimer}
        viewModel={viewModel}
        workspace={workspace}
        viewModelPermissions={viewModelPermissions}
      />
    </>
  );
};
